import { ToastDesignTokens } from '@primeng/themes/types/toast';

export const baseToastToken: ToastDesignTokens = {
  root: {
    borderRadius: '0.5rem',
    borderWidth: '0',
  },
  content: {
    padding: '0',
    gap: '0',
  },
  colorScheme: {
    light: {
      success: {
        background: 'linear-gradient(270deg, #02699C 0%, #00304D 100%);',
        shadow: '0 0.25rem 1.25rem 0 #00000040',
      },
      info: {
        background: '#FFFFFF',
        shadow: '0 0.25rem 1.25rem 0 #00000040',
      },
    },
  },
  css: () => `
    p-toast.fix-absolute .p-toast {
     position: absolute !important;
    }
    `,
};
